module.exports = __webpack_public_path__ + "static/12-026fd1e3b0d6a7ef4ec11bfef9a14903.jpg";